<template>
  <Bar
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip
} from "chart.js";
import { Bar } from "vue-chartjs/legacy";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default {
  name: 'OperationTime',
  components: {
    Bar
  },
  props: {
    data: {
      type: Object,
      default: () => null
    },
    chartId: {
      type: String,
      default: "bar-chart"
    },
    datasetIdKey: {
      type: String,
      default: "label"
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 300
    },
    cssClasses: {
      default: "",
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(val) {
        if (!!val) {
          this.chartData = this.$options.data().chartData
          if (!this.isEmpty(val.delay_time)){
            val.delay_time.forEach(v => {
              this.chartData.labels.push(v.name)
              this.chartData.datasets[0].data.push(v.days)
            })
          }
        }
      }
    }
  },
  data() {
    return {
      chartData: {
        labels: [],
        datasets: [
          {
            label: "Days",
            backgroundColor: "#428AF5",
            data: []
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            offset: true,
            beginAtZero: true,
            stacked: true,
            grid: {
              display: false
            },
            ticks: {
              minRotation: 90,
              callback: function(value) {
                const label = this.getLabelForValue(value)
                return label.length > 15 ? `${label.slice(0, 15)}..` : label;
              }
            }
          }
        }
      }
    }
  }
};
</script>
